import React, { useContext } from 'react';
import { useLaundryBookings } from 'services/laundry/bookings';
import Loader from 'components/loaders/Loader';
import { LaundryBrikkModalContext } from 'components/brikks/home/LaundryService/components/LaundryBrikkContent/index';
import { BookingCard } from './components/BookingCard';
import styles from './styles.module.scss';

export function BookingsAndRemindersSection({ laundryResources }) {
  const { selectedResource } = useContext(LaundryBrikkModalContext);
  const { laundryBookings, isFetching } = useLaundryBookings(
    selectedResource?.id,
  );

  if (isFetching) return <Loader />;

  return (
    <div className={styles.cardsSectionWrapper}>
      {laundryBookings.map((booking) => (
        <BookingCard
          key={booking.id}
          date={booking?.date}
          address={
            laundryResources.find(
              (resource) => resource?.id === booking?.resourceId,
            )?.address
          }
          name={
            laundryResources.find(
              (resource) => resource?.id === booking?.resourceId,
            )?.name
          }
          icon={
            laundryResources.find(
              (resource) => resource?.id === booking?.resourceId,
            )?.icon
          }
          from={booking?.from}
          to={booking?.to}
          endDate={booking?.endDate}
          showRange={booking?.endDate}
        />
      ))}
    </div>
  );
}
